import TodayLoadingLogo from './TodayLoadingLogo';

export default TodayLoadingLogo;
